module.exports = __webpack_public_path__ + "img/47.689c208e.png";